import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_EMAIL = getMessages().getText('board_settings.email.title');
export const BOARD_EMAIL_DESCIPTION = getMessages().getText('board_settings.email.description');
export const BOARD_EMAIL_INSTRUCTION_URL = getMessages().getText('board_settings.email.instruction.url');
export const BOARD_EMAIL_MORE_INSTRUCTIONS = getMessages().getText('board_settings.email.more_instructions');
export const BOARD_EMAIL_DISALLOW = getMessages().getText('noty.system_access.action');
export const BOARD_EMAIL_READONLY = getMessages().getText('board_settings.email.readonly');
